import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/BlogDetails.js");
